import { useEffect, useState } from "react";
import { getDeviceId } from "@/lib/device";

/** Device id, or null while it resolves. `getDeviceId` never rejects. */
export function useDeviceId(): string | null {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    getDeviceId().then(setDeviceId);
  }, []);

  return deviceId;
}
